import React, { useState } from 'react';
import { ContentData } from '../data/contentData';

interface GalleryPageProps {
  content: ContentData;
}

interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  title: string;
  category: string;
  description: string;
  date: string;
}

const GalleryPage: React.FC<GalleryPageProps> = ({ content }) => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);

  // Gallery images data
  const galleryImages: GalleryImage[] = [
    // Academic Activities - Multiple images per topic
    {
      id: 1,
      src: '/images/gallery/academic/25.jpg',
      alt: 'Academic Activity 1',
      title: 'শৈক্ষিক কার্যক্রম - ছবি ১',
      category: 'academic',
      description: 'শ্রেণিকক্ষে শিক্ষাদান ও শিক্ষার্থীদের পড়াশোনা',
      date: '২০২৫'
    },
    {
      id: 2,
      src: '/images/gallery/academic/26.jpg',
      alt: 'Academic Activity 2',
      title: 'শৈক্ষিক কার্যক্রম - ছবি ২',
      category: 'academic',
      description: 'বিজ্ঞান গবেষণাগারে পরীক্ষা-নিরীক্ষা',
      date: '২০২৫'
    },
    {
      id: 3,
      src: '/images/gallery/academic/27.jpg',
      alt: 'Academic Activity 3',
      title: 'শৈক্ষিক কার্যক্রম - ছবি ৩',
      category: 'academic',
      description: 'কম্পিউটার ল্যাবে প্রযুক্তি শিক্ষা',
      date: '২০২৫'
    },
    {
      id: 4,
      src: '/images/gallery/academic/28.jpg',
      alt: 'Academic Activity 4',
      title: 'শৈক্ষিক কার্যক্রম - ছবি ৪',
      category: 'academic',
      description: 'গ্রন্থাগারে পড়াশোনা ও গবেষণা',
      date: '২০২৫'
    },
    {
      id: 5,
      src: '/images/gallery/academic/29.jpg',
      alt: 'Academic Activity 5',
      title: 'শৈক্ষিক কার্যক্রম - ছবি ৫',
      category: 'academic',
      description: 'শ্রেণিকক্ষে গ্রুপ স্টাডি সেশন',
      date: '২০২৫'
    },

    // Cultural Events - Multiple images per topic
    {
      id: 6,
      src: '/images/gallery/cultural/1.jpg',
      alt: 'Cultural Event 1',
      title: 'সাংস্কৃতিক অনুষ্ঠান - ছবি ১',
      category: 'cultural',
      description: 'পহেলা বৈশাখ উদযাপনে সাংস্কৃতিক অনুষ্ঠান',
      date: '২০২৫'
    },
    {
      id: 7,
      src: '/images/gallery/cultural/2.jpg',
      alt: 'Cultural Event 2',
      title: 'সাংস্কৃতিক অনুষ্ঠান - ছবি ২',
      category: 'cultural',
      description: 'স্বাধীনতা দিবস উদযাপনে বিশেষ অনুষ্ঠান',
      date: '২০২৫'
    },
    {
      id: 8,
      src: '/images/gallery/cultural/3.jpg',
      alt: 'Cultural Event 3',
      title: 'সাংস্কৃতিক অনুষ্ঠান - ছবি ৩',
      category: 'cultural',
      description: 'বিজয় দিবসে বিজয় র্যালি ও অনুষ্ঠান',
      date: '২০২৫'
    },
    {
      id: 9,
      src: '/images/gallery/cultural/9.jpg',
      alt: 'Cultural Event 4',
      title: 'সাংস্কৃতিক অনুষ্ঠান - ছবি ৪',
      category: 'cultural',
      description: 'আন্তর্জাতিক মাতৃভাষা দিবসে শ্রদ্ধা নিবেদন',
      date: '২০২৫'
    },
    {
      id: 10,
      src: '/images/gallery/cultural/10.jpg',
      alt: 'Cultural Event 5',
      title: 'সাংস্কৃতিক অনুষ্ঠান - ছবি ৫',
      category: 'cultural',
      description: 'সাংস্কৃতিক অনুষ্ঠানে শিক্ষার্থীদের পরিবেশনা',
      date: '২০২৫'
    },

    // Sports & Activities - Multiple images per topic
    {
      id: 11,
      src: '/images/gallery/sports/4.jpg',
      alt: 'Sports Activity 1',
      title: 'ক্রীড়া ও কার্যক্রম - ছবি ১',
      category: 'sports',
      description: 'বার্ষিক ক্রীড়া দিবসে শিক্ষার্থীদের অংশগ্রহণ',
      date: '২০২৫'
    },
    {
      id: 12,
      src: '/images/gallery/sports/5.jpg',
      alt: 'Sports Activity 2',
      title: 'ক্রীড়া ও কার্যক্রম - ছবি ২',
      category: 'sports',
      description: 'ফুটবল প্রতিযোগিতায় শ্রেণি ভিত্তিক ম্যাচ',
      date: '২০২৫'
    },
    {
      id: 13,
      src: '/images/gallery/sports/6.jpg',
      alt: 'Sports Activity 3',
      title: 'ক্রীড়া ও কার্যক্রম - ছবি ৩',
      category: 'sports',
      description: 'ক্রিকেট প্রতিযোগিতায় সেমি-ফাইনাল ম্যাচ',
      date: '২০২৫'
    },
    {
      id: 14,
      src: '/images/gallery/sports/7.jpg',
      alt: 'Sports Activity 4',
      title: 'ক্রীড়া ও কার্যক্রম - ছবি ৪',
      category: 'sports',
      description: 'ইনডোর গেমস প্রতিযোগিতায় অংশগ্রহণ',
      date: '২০২৫'
    },
    {
      id: 15,
      src: '/images/gallery/sports/8.jpg',
      alt: 'Sports Activity 5',
      title: 'ক্রীড়া ও কার্যক্রম - ছবি ৫',
      category: 'sports',
      description: 'ক্রীড়া দিবসে পুরস্কার বিতরণ অনুষ্ঠান',
      date: '২০২৫'
    },

    // Infrastructure - Multiple images per topic
    {
      id: 16,
      src: '/images/gallery/infrastructure/11.jpg',
      alt: 'Infrastructure 1',
      title: 'পরিকাঠামো - ছবি ১',
      category: 'infrastructure',
      description: 'রাজউক কলেজের মূল ভবনের সামনের দৃশ্য',
      date: '২০২৫'
    },
    {
      id: 17,
      src: '/images/gallery/infrastructure/18.jpg',
      alt: 'Infrastructure 2',
      title: 'পরিকাঠামো - ছবি ২',
      category: 'infrastructure',
      description: 'কলেজের বিশাল খেলার মাঠ ও ক্রীড়া সরঞ্জাম',
      date: '২০২৫'
    },
    {
      id: 18,
      src: '/images/gallery/infrastructure/19.jpg',
      alt: 'Infrastructure 3',
      title: 'পরিকাঠামো - ছবি ৩',
      category: 'infrastructure',
      description: 'কলেজ প্রাঙ্গণের সুন্দর উদ্যান ও গাছপালা',
      date: '২০২৫'
    },
    {
      id: 19,
      src: '/images/gallery/infrastructure/20.jpg',
      alt: 'Infrastructure 4',
      title: 'পরিকাঠামো - ছবি ৪',
      category: 'infrastructure',
      description: 'কলেজের সুন্দর প্রবেশ পথ ও নিরাপত্তা ব্যবস্থা',
      date: '২০২৫'
    },
    {
      id: 20,
      src: '/images/gallery/sports/24.jpg',
      alt: 'Infrastructure 5',
      title: 'পরিকাঠামো - ছবি ৫',
      category: 'infrastructure',
      description: 'কলেজ ভবনের পার্শ্ব দৃশ্য ও পরিবেশ',
      date: '২০২৫'
    },

    // Science Fair - Multiple images per topic
    {
      id: 21,
      src: '/images/gallery/science/12.jpg',
      alt: 'Science Activity 1',
      title: 'বিজ্ঞান মেলা - ছবি ১',
      category: 'science',
      description: 'বার্ষিক বিজ্ঞান মেলার উদ্বোধন ও প্রজেক্ট প্রদর্শন',
      date: '২০২৫'
    },
    {
      id: 22,
      src: '/images/gallery/science/13.jpg',
      alt: 'Science Activity 2',
      title: 'বিজ্ঞান মেলা - ছবি ২',
      category: 'science',
      description: 'বিজ্ঞান মেলায় শিক্ষার্থীদের প্রজেক্ট বিচার',
      date: '২০২৫'
    },
    {
      id: 23,
      src: '/images/gallery/science/14.jpg',
      alt: 'Science Activity 3',
      title: 'বিজ্ঞান মেলা - ছবি ৩',
      category: 'science',
      description: 'বিজ্ঞান প্রদর্শনীতে দর্শকদের অংশগ্রহণ',
      date: '২০২৫'
    },
    {
      id: 24,
      src: '/images/gallery/science/15.jpg',
      alt: 'Science Activity 4',
      title: 'বিজ্ঞান মেলা - ছবি ৪',
      category: 'science',
      description: 'বিজ্ঞান গবেষণাগারে পরীক্ষা ও প্রজেক্ট কাজ',
      date: '২০২৫'
    },
    {
      id: 25,
      src: '/images/gallery/science/16.jpg',
      alt: 'Science Activity 5',
      title: 'বিজ্ঞান মেলা - ছবি ৫',
      category: 'science',
      description: 'বিজ্ঞান মেলায় পুরস্কার বিতরণ অনুষ্ঠান',
      date: '২০২৫'
    },

    // Student Activities - Multiple images per topic
    {
      id: 26,
      src: '/images/gallery/students/21.jpg',
      alt: 'Student Activity 1',
      title: 'ছাত্র কার্যক্রম - ছবি ১',
      category: 'students',
      description: 'ছাত্র পরিষদের নির্বাচন ও সভা কার্যক্রম',
      date: '২০২৫'
    },
    {
      id: 27,
      src: '/images/gallery/students/22.jpg',
      alt: 'Student Activity 2',
      title: 'ছাত্র কার্যক্রম - ছবি ২',
      category: 'students',
      description: 'বিতর্ক প্রতিযোগিতায় শ্রেণি ভিত্তিক অংশগ্রহণ',
      date: '২০২৫'
    },
    {
      id: 28,
      src: '/images/gallery/students/23.jpg',
      alt: 'Student Activity 3',
      title: 'ছাত্র কার্যক্রম - ছবি ৩',
      category: 'students',
      description: 'কুইজ প্রতিযোগিতায় জ্ঞান প্রতিযোগিতা',
      date: '২০২৫'
    },
    {
      id: 29,
      src: '/images/gallery/science/17.jpg',
      alt: 'Student Activity 4',
      title: 'ছাত্র কার্যক্রম - ছবি ৪',
      category: 'students',
      description: 'চিত্রাঙ্কন প্রতিযোগিতায় শিক্ষার্থীদের অংশগ্রহণ',
      date: '২০২৫'
    },
    {
      id: 30,
      src: '/images/gallery/academic/30.jpg',
      alt: 'Student Activity 5',
      title: 'ছাত্র কার্যক্রম - ছবি ৫',
      category: 'students',
      description: 'ছাত্র পরিষদের আয়োজিত বিভিন্ন অনুষ্ঠান',
      date: '২০২৫'
    }
  ];

  // Filter images based on selected category
  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  // Categories for filter
  const categories = [
    { key: 'all', label: 'সব', icon: '🖼️' },
    { key: 'academic', label: 'শৈক্ষিক কার্যক্রম', icon: '📚' },
    { key: 'cultural', label: 'সাংস্কৃতিক অনুষ্ঠান', icon: '🎭' },
    { key: 'sports', label: 'ক্রীড়া ও কার্যক্রম', icon: '⚽' },
    { key: 'infrastructure', label: 'পরিকাঠামো', icon: '🏢' },
    { key: 'science', label: 'বিজ্ঞান মেলা', icon: '🔬' },
    { key: 'students', label: 'ছাত্র কার্যক্রম', icon: '👥' }
  ];

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 bangla-font">🖼️ গ্যালারি</h1>
          <p className="text-xl text-gray-600 bangla-font">রাজউক কলেজের বিভিন্ন কার্যক্রম ও স্মৃতির ছবি</p>
        </div>

        {/* Category Filter */}
        <div className="mb-12">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.key}
                onClick={() => setSelectedCategory(category.key)}
                className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                  selectedCategory === category.key
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600 border border-gray-200'
                }`}
              >
                <span className="mr-2">{category.icon}</span>
                <span className="bangla-font">{category.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
              onClick={() => setSelectedImage(image)}
            >
              {/* Actual image */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    // Fallback to placeholder if image fails to load
                    e.currentTarget.style.display = 'none';
                    const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                    if (nextElement) {
                      nextElement.style.display = 'flex';
                    }
                  }}
                />
                {/* Fallback placeholder */}
                <div className="w-full h-full bg-gradient-to-br from-blue-400 to-purple-600 flex items-center justify-center text-white text-4xl hidden">
                  📷
                </div>
              </div>
              
              <div className="p-4">
                <h3 className="font-semibold text-gray-900 mb-2 bangla-font">{image.title}</h3>
                <p className="text-sm text-gray-600 mb-2 bangla-font">{image.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500 bangla-font">{image.date}</span>
                  <span className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded-full">
                    {categories.find(cat => cat.key === image.category)?.label}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* No Images Message */}
        {filteredImages.length === 0 && (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">📷</div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2 bangla-font">কোন ছবি পাওয়া যায়নি</h3>
            <p className="text-gray-500 bangla-font">অনুগ্রহ করে অন্য ক্যাটাগরি নির্বাচন করুন</p>
          </div>
        )}

        {/* Image Modal */}
        {selectedImage && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <h2 className="text-2xl font-bold text-gray-900 bangla-font">{selectedImage.title}</h2>
                  <button
                    onClick={() => setSelectedImage(null)}
                    className="text-gray-500 hover:text-gray-700 text-2xl"
                  >
                    ✕
                  </button>
                </div>
                
                {/* Actual large image */}
                <div className="w-full h-64 mb-4 rounded-lg overflow-hidden">
                  <img
                    src={selectedImage.src}
                    alt={selectedImage.alt}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // Fallback to placeholder if image fails to load
                      e.currentTarget.style.display = 'none';
                      const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                      if (nextElement) {
                        nextElement.style.display = 'flex';
                      }
                    }}
                  />
                  {/* Fallback placeholder */}
                  <div className="w-full h-full bg-gradient-to-br from-blue-400 to-purple-600 flex items-center justify-center text-white text-8xl hidden">
                    📷
                  </div>
                </div>
                
                <div className="space-y-4">
                  <p className="text-gray-700 bangla-font">{selectedImage.description}</p>
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <span className="bangla-font">তারিখ: {selectedImage.date}</span>
                    <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full">
                      {categories.find(cat => cat.key === selectedImage.category)?.label}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Gallery Stats */}
        <div className="mt-16 bg-white rounded-lg p-8 shadow-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center bangla-font">গ্যালারি পরিসংখ্যান</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">{galleryImages.length}</div>
              <div className="text-gray-600 bangla-font">মোট ছবি</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-600 mb-2">{categories.length - 1}</div>
              <div className="text-gray-600 bangla-font">ক্যাটাগরি</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-purple-600 mb-2">২০২৫</div>
              <div className="text-gray-600 bangla-font">সাল</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-orange-600 mb-2">৬</div>
              <div className="text-gray-600 bangla-font">ইভেন্ট</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryPage;
